import { isNative } from "./platform.js";

/**
 * Inside the native shell ONLY: lock the webview viewport so focusing an input never zooms.
 *
 * WebKit auto-zooms any focused input whose font-size is under 16px (the design system's inputs are
 * 14px, `--ac-fs-lg`), and the zoom leaves the app horizontally scrollable — app-wide, since every
 * screen has inputs (caught in the 2026-08-12 simulator pass on the OTP code step). Pinning
 * `maximum-scale=1` is the standard Capacitor-app fix: a native app has no pinch-zoom expectation
 * (text size comes from OS settings), so nothing is lost in the wrapper.
 *
 * DELIBERATELY a no-op on the web: `maximum-scale=1` there would disable pinch zoom for real browser
 * users — a WCAG 1.4.4 violation. The web keeps its zoomable viewport; browsers other than iOS Safari
 * don't auto-zoom sub-16px inputs in the first place.
 */
export function lockNativeViewport(doc: Document = document): void {
  if (!isNative()) return;

  const meta = doc.querySelector<HTMLMetaElement>('meta[name="viewport"]');
  if (!meta) return;

  const base = meta.content
    .split(",")
    .map((p) => p.trim())
    .filter((p) => p && !p.startsWith("maximum-scale") && !p.startsWith("user-scalable"));
  meta.content = [...base, "maximum-scale=1.0", "user-scalable=no"].join(", ");
}
